var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEconomicAssetsTableIcon = function SvgEconomicAssetsTableIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.486 81.484",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".economicAssetsTableIcon_svg__c{fill-rule:evenodd;fill:#ee741d}"))), /*#__PURE__*/React.createElement("path", {
    d: "M29.006 10.259a1.58 1.58 0 0 1 1.582-1.582h35.674l18.1 20.077v25.233s.061 20.843-5.862 30.794a1.57 1.57 0 0 1-1.332.734H25.13a1.58 1.58 0 0 1-1.4-2.325c4.908-10.656 5.267-29.207 5.267-29.207Z",
    style: {
      fill: "#d2dfea",
      fillRule: "evenodd"
    },
    transform: "translate(12.12 -4.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.366 37.323s.057 20.843-5.864 30.793a1.57 1.57 0 0 1-1.332.734H25.132a1.58 1.58 0 0 1-1.4-2.325l.062-.136c19.478.916 47.762-2.5 51.487-3.954 3.98-1.558 9-16.509 9.078-24.92Z",
    style: {
      fillRule: "evenodd",
      fill: "#63849f"
    },
    transform: "translate(12.12 12.63)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.486 24.719c-4.8-1.9-9.886-1.95-15.1-1.145a1.575 1.575 0 0 1-1.813-1.724 56.5 56.5 0 0 0-1.192-17.208 65.4 65.4 0 0 1 18.1 20.077Z",
    className: "economicAssetsTableIcon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.009 12.068A19.852 19.852 0 0 1 41.74 41.686l2.605 8.261a1.14 1.14 0 0 1-.28 1.15l-.221.221a1.07 1.07 0 0 1-1.079.263l-8.3-2.618a19.8 19.8 0 0 1-7.478 2.5c.019-.524.025-.811.025-.811Z",
    style: {
      fillRule: "evenodd",
      fill: "#a4bbdb"
    },
    transform: "translate(14.116 -2.062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.916 47.2a18.98 18.98 0 1 1 6.958-6.958l2.49 7.9a1.09 1.09 0 0 1-.267 1.1l-.212.212a1.02 1.02 0 0 1-1.031.253Z",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    },
    transform: "translate(5.662 -2.233)"
  }), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.746 22.839a3.75 3.75 0 0 1 1.4-3.254 3.45 3.45 0 0 1 4.536.285 3.36 3.36 0 0 1 .764 2.267c.019 2.313-1.068 3.665-2.129 5.066-1.43 1.887-2.858 3.826-3.035 7.064a1.582 1.582 0 0 0 3.159.172c.134-2.46 1.311-3.893 2.4-5.326 1.455-1.919 2.8-3.833 2.771-7a6.44 6.44 0 0 0-1.566-4.343 6.684 6.684 0 0 0-8.78-.731 6.8 6.8 0 0 0-2.689 5.875 1.581 1.581 0 0 0 3.162-.074Z",
    className: "economicAssetsTableIcon_svg__c"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1.946,
    cy: 1.946,
    r: 1.946,
    style: {
      fill: "#ee741d"
    },
    transform: "translate(34.77 37.917)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.742 2.565 6.327 7.959a1.582 1.582 0 1 0 2.477-1.966L20.219.598a1.582 1.582 0 0 0-2.477 1.968ZM.794 6.524l16.532 9.49a1.581 1.581 0 1 0 1.574-2.743L2.369 3.781A1.582 1.582 0 0 0 .794 6.524M3.164 24.133h11.072a1.582 1.582 0 0 0 0-3.163H3.164a1.582 1.582 0 0 0 0 3.163",
    className: "economicAssetsTableIcon_svg__c"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEconomicAssetsTableIcon);
export default ForwardRef;